import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';

export const archiveProductMutation = gql`
  mutation archiveProduct($id: Int!) {
    archiveProduct(id: $id) {
      id
    }
  }
`;

export class ProductArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderNopeModalInner = () => {
    // You can't delete an product if it has lots
    const { lots, name } = this.props.product;

    return (
      <Fragment>
        <ModalHeader toggle={this.onToggle}>Cannot archive</ModalHeader>
        <ModalBody>
          <p className="mb3">
            You can't archive <em>{name}</em> as it already been used in some lots:
          </p>
          <ul className="mb0">
            {lots.map(({ lot }) => (
              <li key={lot.id}>{lot.reference}</li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onToggle}>
            Ok
          </Button>{' '}
        </ModalFooter>
      </Fragment>
    );
  };

  renderConfirmationModalInner = () => {
    const { client, product, history } = this.props;
    const { name } = product;
    const { submitting, error } = this.state;
    return (
      <Mutation mutation={archiveProductMutation}>
        {archiveProduct => (
          <Fragment>
            <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              Are you sure you want to archive the product <em>{name}</em>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.onToggle}>
                Cancel
              </Button>{' '}
              <Button
                disabled={submitting}
                color="primary"
                onClick={async () => {
                  try {
                    this.setSubmitting(true);
                    await archiveProduct({
                      variables: {
                        id: product.id
                      }
                    });
                    // Clear cache
                    client.resetStore();
                    history.push(`/products?archived=${name}`);
                  } catch (err) {
                    this.setSubmitting(false);
                    this.setError('An unknown error occured');
                  }
                }}
              >
                Archive
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    const { className, product } = this.props;

    if (!product) {
      // In some cases where product comes though asyncronously, there is a chance that the product
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    return (
      <Fragment>
        <Button className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          {this.renderConfirmationModalInner()}
          {/* {Note - do the below when lots are in kplace} */}
          {/* {product.lots.length ? this.renderNopeModalInner() : this.renderConfirmationModalInner()} */}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(ProductArchive));



// WEBPACK FOOTER //
// ./src/containers/productArchive/productArchive.jsx